// extracted by mini-css-extract-plugin
export default {"emptyValuesMessage":"filterLabels_emptyValuesMessage__8Ue0E","filterValue":"filterLabels_filterValue__uZKzr","removeFilterBtn":"filterLabels_removeFilterBtn__pIykZ"};